export const retraite = {
  profil : 'Retraité',
  firstname : "Jean-Jacques",
  name : "Dupont",
  pack : {
    type : 'Santé',
    name : 'UNAKER',
    option : 'Formule privilège',
  },
  demandes: [
    {
      demande_date: '16/02/2022',
      demande_motif: 'Remboursement IFC',
      demande_salary: 'Vincent Goncalves',
      demande_status: 'uncomplete'
    },
    {
      demande_date: '12/02/2022',
      demande_motif: 'Remboursement IFC',
      demande_salary: 'Vincent Goncalves',
      demande_status: 'progressing'
    },
    {
      demande_date: '10/02/2022',
      demande_motif: 'Remboursement IFC',
      demande_salary: 'Vincent Goncalves',
      demande_status: 'uncomplete'
    },
    {
      demande_date: '09/02/2022',
      demande_motif: 'Remboursement IFC',
      demande_salary: 'Vincent Goncalves',
      demande_status: 'clotured'
    },
    {
      demande_date: '07/02/2022',
      demande_motif: 'Remboursement IFC',
      demande_salary: 'Vincent Goncalves',
      demande_status: 'clotured'
    }
  ],
  payments: [
    {
      payment_motif: 'Remboursement IFC',
      payment_salary: 'Vincent Goncalves',
      payment_status: 'paiement réalisé',
      payment_price: '500',
      payment_date: '16/02/2022',
    },
    {
      payment_motif: 'Déclaration d\'arret de travail',
      payment_salary: 'Vincent Goncalves',
      payment_status: 'paiement gelé',
      payment_price: '200',
      payment_date: '16/02/2022',
    },
    {
      payment_motif: "déclaration d'un décès",
      payment_salary: 'Vincent Goncalves',
      payment_status: 'paiement réalisé',
      payment_price: '300',
      payment_date: '16/02/2022',
    }
  ],
  documents : [
    {
      title: 'Santé',
      subtitle: 'Mes documents',
      files : [
        { title: 'Tableau de garantie', link: '#'},
        { title: "Notice d'information", link: '#'},
      ]
    },
    {
      title: 'Dépendance',
      subtitle: 'Mes garanties',
      files : [
        { title: 'Tableau de garantie', link: '#'},
        { title: "Notice d'information", link: '#'},
      ]
    }
  ]
}
